import { LoaderScreen } from "pages/loaderscreen";
import React, { createContext, useEffect, useState } from "react";



export const PageLoaderDuration= 5000
const PageLoaderContext = React.createContext<{
  hasLoaded: boolean;
  markAsLoaded: () => void;
}>({ hasLoaded: false, markAsLoaded: () => {} });

interface PageLoaderContextProviderProps {}
const PageLoaderContextProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [hasLoaded, setHasLoaded] = useState(false);
  const markAsLoaded = () => {
    setHasLoaded(true);
  };
  useEffect(() => {
    setTimeout(() => {
      markAsLoaded();
    }, PageLoaderDuration);
  },[])
  return (
    <PageLoaderContext.Provider value={{ hasLoaded, markAsLoaded }}>
      {/* {!hasLoaded ? <LoaderScreen /> : children} */}
      {/* <LoaderScreen /> */}
      {children}
    </PageLoaderContext.Provider>
  );
};

export { PageLoaderContext, PageLoaderContextProvider };
